import { getAuthToken } from "@/features/shared/features/authentication";
import { DimensionValueSet } from "@/lib/dimensions";

export default class LayerLegendImageLoader {
  private dashboardId;
  private mapLayerId;

  constructor(dashboardId: string, mapLayerId: string) {
    this.dashboardId = dashboardId;
    this.mapLayerId = mapLayerId;
  }

  async loadLegendImage(dimensionValues: DimensionValueSet): Promise<Blob | undefined> {
    const response = await fetch(this.legendImageUrl(dimensionValues), {
      headers: {
        Authorization: `Bearer ${getAuthToken()?.access_token}`,
      },
    });

    if (!response.ok) throw new Error(response.statusText, { cause: response });

    return response.blob();
  }

  private legendImageUrl(dimensionValues: DimensionValueSet): string {
    const queryString = new URLSearchParams(
      this.mapDimensionsToQueryString(dimensionValues),
    );
    return `${import.meta.env.VITE_API_BASE_PATH}/published/dashboards/${
      this.dashboardId
    }/map_layers/${this.mapLayerId}/legend?${queryString.toString()}`;
  }

  private mapDimensionsToQueryString(dimensionValues: DimensionValueSet) {
    return Object.entries(dimensionValues).reduce<{
      [dimensionId: string]: string;
    }>((acc, [id, value]) => {
      acc[`dimension_${id}`] = value.queryStringValue;
      return acc;
    }, {});
  }
}
